import script from "./FooterComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./FooterComponent.vue?vue&type=script&lang=ts&setup=true"

import "./FooterComponent.vue?vue&type=style&index=0&id=53c0a42a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53c0a42a"]])

export default __exports__